module Meevo.Plugins.AppointmentBook {
    class NotesController {
        private modal;
        private globals;
        actions: any;
        helper: any;
        editorService: any;
        restServer: any;
        originalCopy: any;

        static $inject = ['appointmentBookActionsService', 'appointmentBookGlobalsService', 'appointmentBookModalService', 'appointmentBookHelperService', 'restServer', 'AppointmentEditorService'];

        constructor(actions, globals, modal, helper, restServer, editorService) {
            this.modal = modal;
            this.globals = globals;
            this.actions = actions;
            this.helper = helper;
            this.restServer = restServer;
            this.editorService = editorService;

            this.originalCopy = {
                note: this.editorService.currentAppointment.note,
                noteType: this.editorService.local.noteType
            }
            
        }
        

        closeAndErase = () => {
            this.editorService.currentAppointment.note = this.originalCopy.note;
            this.editorService.local.noteType = this.originalCopy.noteType;
            this.modal.hideModal();
        }
    }
    angular.module("ApptBookApp")
        .controller("meevo.plugins.appointmentBook.NotesController", NotesController);
}